var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-page',{attrs:{"title-text":"员工信息完善度","request":_vm.request,"column-list":_vm.columnList,"table-size":"large","title-menus":[],"table-actions":[],"table-actions-fixed":true,"need-data-file":true}},[_c('div',{staticClass:"ir-t",attrs:{"slot":"title"},slot:"title"},[_c('progress-dom',{attrs:{"value":_vm.allRate,"label":"信息完善度"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }